import { genderType } from "redux/commonTypes";
import { photoType } from "../users/usersTypes";

export const actionTypes = {
  SET_PHOTO_ERROR: "PHOTO:SET_PHOTO_ERROR",
  SET_PHOTO_LOADING: "PHOTO:SET_LOADING",
  SET_FIRST_PHOTO_LOADED: "PHOTO:SET_FIRST_PHOTO_LOADED",
  SET_PHOTO_WAS_DELETED: "PHOTO:SET_PHOTO_WAS_DELETED",
  SET_PUBLIC_PHOTOS: "PHOTO:SET_PUBLIC_PHOTOS",
  SET_PRIVATE_PHOTOS: "PHOTO:SET_PRIVATE_PHOTOS",
  SET_PRIVATE_PHOTOS_REQUESTS: "PHOTO:SET_PRIVATE_PHOTOS_REQUESTS",
  SET_PRIVATE_PHOTOS_ACCESSED_USERS: "PHOTO:SET_PRIVATE_PHOTOS_ACCESSED_USERS",
  SET_GESTURE: "PHOTO:SET_GESTURE",
  SET_VERIFY_RESULT: "PHOTO:SET_VERIFY_RESULT",
  SET_LOADING_PUBLIC: "PHOTOS:SET_LOADING_PUBLIC",
  SET_LOADING_PRIVATE: "PHOTOS:SET_LOADING_PRIVATE",
  SET_CANT_DEL_LAST: "PHOTOS:SET_CANT_DEL_LAST"
};

export enum photoResponses {
  photoIsNotYours = 1488, //TODO
  photoFormatErr = 54,
  fileTooLarge = 52,
  adultPhoto = 56,
  incorrectPhoto = 57,
  NoContentTypeMultiPart = 53,
  IncorrectContentType = 54,
  EmptyMultiPart = 55,
  GruesomePhoto = 86, 
  ServiceUnavailable = 87,  
  UserAlreadyVerified = 109, 
  VerificationGestureNotFound = 110, //
  VerificationGestureInPhotoNotFound = 111, //
  VerificationServiceUnavailable = 112, 
  IncorrectGesture = 113, //
  VerificationHandNotFound = 114, //
  VerificationFaceNotFound = 115, //
  VerificationManyFace = 116, //
  OnlyFemale = 117, //
  lastFemalePhoto = 74,
  invalidCrop = 129,
  tooBigPhoto = 103
}

export enum galleryTypes {
  Public = 0,
  Private = 1,
}

export type privatePhotoRequest = {
  previewUser: {
    id: string;
    name: string;
    sex: genderType;
    birthday: string;
    city: {
      id: number;
      name: string;
    };
  };
  mainPhoto: photoType;
};

export type privatePhotoAccessedUser = {
  previewUserInfo: {
    id: string;
    name: string;
    birthday: string;
    city: {
      id: number;
      name: string;
    };
  };
  mainPhoto: photoType;
};

export enum gestTypes {
  horn = 0,
  loser = 1,
  fist = 2,
  religion = 3,
  seven = 4,
}
